import { createAsyncThunk } from '@reduxjs/toolkit';
import { setToken, removeToken } from '../../services/auth/index.js';
import { G as GenerateCustomerToken, C as CreateCustomer } from '../../GenerateCustomerToken-nBNO7Rhh.js';
import { G as GetCustomerInfo } from '../../GetCustomerInfo-QRC3rgNh.js';
import { b as publicMutate, a as privateQuery } from '../../requestsCollection-A0HzS4ai.js';
import { extractErrorMessage } from '../../utils/error.js';
import '../../utils/logToSlack.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../utils/currency.js';
import 'react';
import '../../context/index.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import 'next/router';
import '../../helpers-WYINLSKJ.js';
import 'lodash';
import 'lodash/cloneDeep';
import { d as dataLayerRegister } from '../../register-J9OaMUYD.js';
import { assignCartFromGuestToLogged, deleteCartSessionId, deleteCartGtmData } from '../../utils/cart.js';
import { addProductToWishlistAfterAuth } from '../../utils/wishlist.js';
import { createWishlist, clearWishlist } from '../wishlist/index.js';
import '../../utils/cookies.js';
import '../../cookies-VX_DpI1q.js';
import '../../utils/isBot.js';
import 'graphql-request';
import '../../utils/fetchPolicyLookup.js';
import '../../serverErrors-O6unZmFR.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../paths-ZKN3m62_.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-AU0vdOfm.js';
import '../wishlist/thunks.js';
import '../../RemoveProductsFromWishlist-WCaYiZlq.js';
import '../../wishlist-foOHzuD7.js';
import '../../utils/parseJSON.js';
import '../../localStorage-h6SlcHvK.js';
import '../../utils/transformWishlistModel.js';
import '../genericSlice.js';
import 'lodash/set';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../modal-6vnX5SO3.js';
import '../wishlist/initialState.js';

const login = createAsyncThunk('user/login', async (payload, { extra, rejectWithValue, dispatch }) => {
    try {
        const { apolloConfig } = extra;
        const token = await publicMutate(apolloConfig(), {
            mutation: GenerateCustomerToken,
            variables: payload,
        }).then(res => res.data.generateCustomerToken.token);
        setToken(token);
        const userInfo = await privateQuery(apolloConfig(), {
            query: GetCustomerInfo,
        }, 'GetCustomerInfo').then(res => res.data.customer);
        const { wishlists, ...currentUser } = userInfo;
        dispatch(createWishlist(wishlists));
        // Add product to the wishlist after login
        await addProductToWishlistAfterAuth(dispatch, wishlists);
        // Assign shopping cart after login
        await assignCartFromGuestToLogged(apolloConfig);
        return currentUser;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});
const logout = createAsyncThunk('user/logout', async (_, { rejectWithValue, dispatch }) => {
    try {
        removeToken();
        dispatch(clearWishlist());
        deleteCartSessionId();
        deleteCartGtmData();
        return null;
    }
    catch (e) {
        return rejectWithValue({ errorMessage: 'Error logout' });
    }
});
const register = createAsyncThunk('user/register', async (payload, { extra, rejectWithValue, dispatch }) => {
    try {
        const { apolloConfig } = extra;
        // We can't get wishlist data within this response due to the Magento error
        // "The current user cannot perform operations on wishlist"
        const user = await publicMutate(apolloConfig(), {
            mutation: CreateCustomer,
            variables: payload,
        }).then(res => res.data.createCustomer.customer);
        const token = await publicMutate(apolloConfig(), {
            mutation: GenerateCustomerToken,
            variables: { email: payload.email, password: payload.password },
        }).then(res => res.data.generateCustomerToken.token);
        setToken(token);
        const userInfo = await privateQuery(apolloConfig(), {
            query: GetCustomerInfo,
        }, 'GetCustomerInfo').then(res => res.data.customer);
        const { wishlists } = userInfo;
        dispatch(createWishlist(wishlists));
        // Add product to the wishlist after register
        await addProductToWishlistAfterAuth(dispatch, wishlists);
        await assignCartFromGuestToLogged(apolloConfig);
        dataLayerRegister();
        return user;
    }
    catch (e) {
        return rejectWithValue({
            errorMessage: extractErrorMessage(e),
        });
    }
});

export { login, logout, register };
//# sourceMappingURL=thunks.js.map
